/**
 * A platform mérési azonosítói (F1d, 2026-10-08): egy Meta pixel és egy Google Ads fiók az egész platformra, az irodákat
 * a kampányok és az UTM-paraméterek választják szét. Az azonosítók nem titkok, de a landing HTML-be csak pontos formátumú
 * érték kerülhet.
 */
export interface PlatformMeres { metaPixelId: string | null; googleAdsId: string | null; googleLeadCimke: string | null }
export const META_PIXEL_MINTA = /^\d{10,20}$/;
export const GOOGLE_ID_MINTA = /^AW-\d{6,15}$/;
export const GOOGLE_CIMKE_MINTA = /^[A-Za-z0-9_-]{6,40}$/;
const illik = (v: unknown, re: RegExp) => (typeof v === 'string' && re.test(v.trim()) ? v.trim() : null);

/** A hibás vagy üres érték null (akkor az adott mérés nem indul); a Google-azonosító és a címke csak együtt érvényes. */
export function meresKonfig(env: { metaPixelId?: string; googleAdsId?: string; googleLeadCimke?: string }): PlatformMeres {
  const id = illik(env.googleAdsId, GOOGLE_ID_MINTA);
  const cimke = illik(env.googleLeadCimke, GOOGLE_CIMKE_MINTA);
  return { metaPixelId: illik(env.metaPixelId, META_PIXEL_MINTA), googleAdsId: id && cimke ? id : null, googleLeadCimke: id && cimke ? cimke : null };
}

/** Az iroda hirdetési linkje UTM-mel: a CRM ebből (`utm_campaign`) azonosítja a kampányt. */
export function hirdetesiLink(alapUrl: string, slug: string, forras: 'facebook' | 'google'): string {
  const u = new URL(`/${encodeURIComponent(slug)}`, alapUrl);
  u.search = new URLSearchParams({ utm_source: forras, utm_medium: 'paid', utm_campaign: slug }).toString();
  return u.toString();
}
